import { GET } from 'shared/utils/ajax';

const media = `/rest/media`;
const path = media + `/search`;

export const searchText$ = text => GET(`${path}/${encodeURI(text)}`);
